export enum AccessLevel {
    NoLoginAllowed = 0,
    FullAccess = 1,
    DiaryOnly = 2,
    EmergencyOnly = 3,
}
